import Constants from "../constants/application";

/**
 * Clear contacts, segments on APP.RESET_ORGANISATION
 * @param {Object} state - The state
 * @param {Object} action - The action
 * @returns {Object} The state
 */
export function clearApp(state, action) {
	if (action.type !== Constants.APPLICATION.RESET) {
		// Unless RESET do nothing
		return state;
	}

	// Avoid to reset connect if we have already loaded
	if (state.connect) {
		return { connect: state.connect };
	}

	return {};
}
